import { render, staticRenderFns } from "./Aging.vue?vue&type=template&id=78c42b26"
import script from "./Aging.vue?vue&type=script&lang=js"
export * from "./Aging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports